<div class="content">
  <div class="symbol" *ngIf="hasSymbol && (icon || symbol)" [class.no-margin]="!!symbol">
    <ng-content select="rt-icon"></ng-content>
    <ng-content select="rt-checkbox"></ng-content>
  </div>

  <div class="text-content">
    <ng-content></ng-content>
  </div>

  <div *ngIf="hasChevronRight" class="symbol right">
    <rt-icon name="chevron-right"></rt-icon>
  </div>

  <ng-content select="rt-button.close-dropdown"></ng-content>
</div>

<ng-container *ngIf="hrefTarget && href">
  <a [href]="href" target="{{ hrefTarget }}"></a>
</ng-container>
<ng-container *ngIf="!hrefTarget && href">
  <a [href]="href"></a>
</ng-container>

<rt-divider *ngIf="!noDivider"></rt-divider>
